import type { Ref } from "react";
import { useRef } from "react";
// eslint-disable-next-line no-restricted-imports
import { FlatList as RNFlatList, type FlatListProps } from "react-native";
import { withUnistyles } from "react-native-unistyles";

import { mergeRefs, ScrollProvider } from "$src/core/contexts/scroll";

const FlatList = (({
  ref: forwardedRef,
  ...props
}: FlatListProps<any> & { ref?: Ref<RNFlatList<any>> }) => {
  const ref = useRef<RNFlatList<any> | null>(null);

  return (
    <ScrollProvider scrollRef={ref}>
      <RNFlatList {...props} ref={mergeRefs(ref, forwardedRef)} />
    </ScrollProvider>
  );
}) as unknown as typeof RNFlatList;

export default withUnistyles(FlatList) as unknown as typeof RNFlatList;
